import { BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import React from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/auth';
import NotFoundPage from './pages/NotFoundPage';
import Home from './pages/Home';
import Profil from './pages/Profil';
import Profil_Düzenle from './pages/Profil_Düzenle';
import CreatePost from './pages/CreatePost';
import GirişYap from './pages/GirişYap';
import KayıtOl from './pages/KayıtOl';
import Search from './pages/Search';
import PostId from './pages/[postId]';
import UserId from './pages/[UserId]';
import Dashboard from './pages/Dashboard';
import Bildirimler from './pages/Bildirimler';
import Taslaklar from './pages/Taslaklar';
import Yazarlar from './pages/Yazarlar';
import Changelog from './pages/Changelog';
import RedirectToPost from "./pages/RedirectToPost";
import {SSS, StartPage, Yazılar, Yorumlar, Bildirimler2, Profiller} from './sss/SSS';
import './css/App.css';
import { database, auth } from './firebase';

class App extends React.Component {
constructor(props) {
  super(props);
  this.app = firebase.app();
  this.database = this.app.database().ref().child('posts');
  this.database2 = this.app.database().ref().child('users');
  this.database3 = this.app.database().ref().child('drafts');
  this.state = {
    posts: [],
    users: [],
    users2: [],
    drafts: [],
  };
}

componentWillMount() {
  
  //database.ref("!stats").push().set({
  //  view: true
  //})

  //var views = 0;TODO
  //database.ref("!stats").child("asdf").get().then(function(snap) {
  //  console.log(snap.val())
  //  views = views + snap.val().asdf + 1;
  //  database.ref("!stats").child("asdf").set({
  //    asdf: views
  //  })
  //})
  
  const previousPosts = this.state.posts;
  this.database.on('child_added', snap => {
    if (!previousPosts.includes(snap)) previousPosts.push({
        id: snap.key,
        postTitle: snap.val().postTitle,
        postContent: snap.val().postContent,
        postDate: snap.val().postDate,
        postImage: snap.val().postImage,
        postAuthor: snap.val().postAuthor
    })
    
    this.setState({
        posts: previousPosts,
    })
  })

  const previousUsers = this.state.users;
  this.database2.on('child_added', snap => {
    this.state.users2.push({
      id: snap.key,
      userName: snap.val().userName,
      uid: snap.val().uid,
      bio: snap.val().bio,
      userEmail: snap.val().email,
      userImage: snap.val().userImage,
      verified: snap.val().verified
    })
    if (!previousUsers.includes(snap)) previousUsers.push({
      id: snap.key,
      userName: snap.val().userName,
      uid: snap.val().uid,
      bio: snap.val().bio,
      userEmail: snap.val().email,
      userImage: snap.val().userImage,
      verified: snap.val().verified
    })
    
    this.setState({
      users: previousUsers,
    })
  })

  const previousDrafts = this.state.drafts;
  auth.onAuthStateChanged((user) => {
    if (user) database.ref("drafts/"+user.uid).get().then((snap) => {
      snap.forEach(s => {if (!previousDrafts.includes(snap)) previousDrafts.push({
        id: s.key,
        draftTitle: s.val().draftTitle,
        draftContent: s.val().draftContent,
        draftDate: s.val().draftDate,
        draftImage: s.val().draftImage,
        draftAuthor: s.val().draftAuthor,
        draftShared: s.val().draftShared
      })})

      this.setState({
        drafts: previousDrafts,
      })
    })
  })
}

render() {
  function setTheme(themeName) {
      localStorage.setItem('theme', themeName);
      document.documentElement.className = themeName;
  }

  /*(function () {
    if (localStorage.getItem('theme') === 'theme-dark') {
        setTheme('theme-dark');
    } else {
        setTheme('theme-light');
    }
  })();*/

  return (
    <div>
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profil" element={<Profil />} />
          <Route path="/profil/duzenle" element={<Profil_Düzenle />} />
          <Route path="/giris-yap" element={<GirişYap />} />
          <Route path="/kayit-ol" element={<KayıtOl />} />
          <Route path="/ara" element={<Search />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/bildirimler" element={<Bildirimler />} />
          <Route path="/taslaklar" element={<Taslaklar />} />
          <Route path="/yazarlar" element={<Yazarlar />} />
          <Route path="/profil/:id" element={<UserId />} />
          <Route path="/yazi/:id" element={<RedirectToPost />} />
          <Route path="/p/:id" element={<PostId />} />
          <Route path="/taslak/:id" element={<CreatePost />} />
          <Route path="/sss" element={<SSS />} />
          <Route path="/sss/start" element={<StartPage />} />
          <Route path="/sss/yazilar" element={<Yazılar />} />
          <Route path="/sss/yorumlar" element={<Yorumlar />} />
          <Route path="/sss/bildirimler" element={<Bildirimler2 />} />
          <Route path="/sss/profil" element={<Profiller />} />
          <Route path="/surum-notlari" element={<Changelog />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}};

export default App;